import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import memoizeOne from 'memoize-one';
// downgrades the new dispatch function to be compatible with the old dispatch shape
// this is required for the components that use the old dispatch
export var downgradeDispatch = memoizeOne(function (dispatch) {
  return function (legacyEffects) {
    return Promise.all((Array.isArray(legacyEffects) ? legacyEffects : [legacyEffects]).map(function (legacyEffect) {
      switch (legacyEffect.type) {
        case 'initialize':
          {
            return dispatch({
              type: 'render',
              extensionData: {}
            });
          }
        case 'event':
          {
            return dispatch({
              type: 'event',
              handler: legacyEffect.handler,
              args: legacyEffect.args,
              extensionData: {}
            });
          }
        default:
          throw Error("Cannot dispatch \"".concat(legacyEffect.type, "\" effect"));
      }
    })).then(function () {});
  };
});

// upgrades the component function to the new component map API
// this is temporary while we upgrade the component functions to new API
export var upgradeComponent = function upgradeComponent(Comp) {
  return function (_ref) {
    var forgeDoc = _ref.forgeDoc,
      _render = _ref.render,
      dispatch = _ref.dispatch;
    var children = forgeDoc.children,
      key = forgeDoc.key,
      props = forgeDoc.props,
      type = forgeDoc.type;
    return /*#__PURE__*/React.createElement(Comp, {
      type: type,
      key: key,
      props: props,
      dispatch: downgradeDispatch(dispatch),
      children: children,
      Components: {} /* no components actually use this component map */,
      render: function render(props) {
        return _render(props.aux);
      },
      renderChildren: function renderChildren(props) {
        return props.children.map(_render);
      }
    });
  };
};